module.exports = {
    parse: require('./lib/parse'),
    stringify: require('./lib/stringify')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/html-parse-stringify2/index.js
// module id = 1448
// module chunks = 0